//import Libraries
import React, { Component } from 'react'
import {connect} from 'react-redux';

//import Components
import Layout from '../../hoc/Layout/Layout';

import CategoryBar from './CategoryBar';
import DetailProductList from './DetailProduct/DetailProductList';
import SimpleProductList from './SimpleProduct/SimpleProductList';

import Cart from './Cart/Cart'

import Loading from '../../components/Loading/Loading';

//import actions
import * as productActions from './actions/productActions';
import * as categoryActions from './actions/categoryActions';

//import Style classes
import './Store.css';

class Store extends Component{
    constructor(props){
        super(props);
    }
    state = {
        selectedCategory : 'all',
        selectedMain : -1,
        selectedSub : -1,
    }

    categoryClickHandler = (main, sub, id) => {
        if(sub === -1) {
            if(this.state.selectedMain === main) {
                this.setState({ selectedMain : -1, selectedSub : -1, selectedCategory : 'all' });
                return;
            }
        }
        else {
            if(this.state.selectedSub === sub) {
                this.setState({ selectedMain : -1, selectedSub : -1, selectedCategory : 'all' })
                return;
            }
        }
        this.setState({
            selectedCategory: id,
            selectedMain : main, 
            selectedSub : sub
        })
    }

    componentDidMount(){
        this.props.onLoadProducts();
        this.props.onLoadCategory();
    }

    render(){

        const loading = !this.props.products || !this.props.category.mainCategory || !this.props.category.subCategory;
        if(loading) {
            return (
                <Layout relative={true} isStore={true}>
                    <Loading text={"This is Store page"} />
                </Layout>
            );
        }
        let filteredProducts = [...this.props.products];
        filteredProducts = filteredProducts.filter((product) => {
            return (product.category.mainCategory >= 0) && (product.category.subCategory >= 0);
        })

        if(this.state.selectedMain !== -1) {
            filteredProducts = filteredProducts.filter((product) => {
                return product.category.mainCategory === this.state.selectedMain;
            })
        }
        if(this.state.selectedSub !== -1) {
            filteredProducts = filteredProducts.filter((product) => {
                return  product.category.subCategory === this.state.selectedSub;
            })
        }

        filteredProducts.sort((a, b) => {
            if (a.category.mainCategory < b.category.mainCategory || 
               (a.category.mainCategory === b.category.mainCategory && a.category.subCategory < b.category.subCategory)) {
                return -1;
            } else if (a.category.mainCategory > b.category.mainCategory || 
                      (a.category.mainCategory === b.category.mainCategory && a.category.subCategory > b.category.subCategory)) {
                return 1;
            } else {
                return 0;
            }
        })

        const renderNotLoading = (
            <div className="StoreWrapper">
                <Cart />
                <hr/>
                <CategoryBar 
                    currentCategory={this.state.selectedCategory}
                    categoryClickHandler={this.categoryClickHandler}/>
                {
                    this.props.simpleStore ? 
                        <SimpleProductList 
                            universal={this.props.universal}
                            products={filteredProducts}
                        />
                    : 
                        <DetailProductList 
                            universal={this.props.universal}
                            products={filteredProducts}
                        />
                }
            </div>
        );

        return (
            <Layout relative={true} isStore={true}>
            {
                 renderNotLoading 
            }
            </Layout>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        universal : state.universal,
        products : state.products,
        category : state.category,
        user : state.user,
        simpleStore : state.store.simpleStore
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return{
        onLoadProducts : ()=> {
            dispatch(productActions.loadProducts());
        },
        onLoadCategory : () => {
            dispatch(categoryActions.loadCategory());
        }

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Store);


// WEBPACK FOOTER //
// ./src/pages/Store/Store.js